import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { MessageService, MenuItem } from 'primeng/api';
import { XpressDisciplinaryService } from 'app/services';
import { XpressDisciplinaryStatus, XpressDisciplinaryActionEnum } from 'app/models';
import { Utils } from 'app/utils';
import moment from 'moment';

enum MenuTab {
    Details = 1,
    Investigation = 2,
    Hearing = 3,
    Disciplinary = 4
}

@Component({
    selector: 'disciplinary-detail',
    templateUrl: './disciplinary-detail.component.html',
    styleUrls: ['./disciplinary-detail.component.scss',
        '../../../../../styles/sidebar.scss',
        '../../../../../styles/style-layout.scss'
    ],
    providers: [MessageService]
})
export class DisciplinaryDetailComponent implements OnInit {
    public disciplinaryId: number = 0;
    @Input()
    set _disciplinaryId(value: number) {
        this.disciplinaryId = value;
    }

    @Input() public showDisciplinaryDetailSideBar: boolean = false;

    constructor(private messageService: MessageService, private disciplinaryService: XpressDisciplinaryService) {
    }

    @Output() changedShowDisciplinaryDetailSideBarEmit = new EventEmitter<boolean>();
    changedShowDisciplinaryDetailSideBar(increased: any) {
        this.changedShowDisciplinaryDetailSideBarEmit.emit(increased);
    }

    public menuTab = MenuTab;
    public activeMenuTab: MenuTab = MenuTab.Details;
    public menuItems: MenuItem[] = [
        {
            label: 'Details',
            id: `${MenuTab.Details}`,
            command: (e: any) => this.handleTabChange(+e.item.id)
        },
        {
            label: 'Investigation',
            id: `${MenuTab.Investigation}`,
            command: (e: any) => this.handleTabChange(+e.item.id)
        },
        {
            label: 'Hearing',
            id: `${MenuTab.Hearing}`,
            command: (e: any) => this.handleTabChange(+e.item.id)
        },
        {
            label: 'Disciplinary',
            id: `${MenuTab.Disciplinary}`,
            command: (e: any) => this.handleTabChange(+e.item.id)
        }
    ];

    public loading: boolean = false;
    public disciplinary!: any;

    ngOnInit(): void {
        this.getDetailDisciplinary();
    }

    public handleTabChange(tab: MenuTab) {
        this.activeMenuTab = tab;
    }

    public getDetailDisciplinary() {
        this.loading = true;
        const dto = {
            DisciplinaryId: this.disciplinaryId,
            TimeZoneOffset: Utils.getTimezoneOffset()
        };
        this.disciplinaryService.getDetailDisciplinary(dto, this.messageService)
            .then(data => {
                if (!data) {
                    this.loading = false;
                    return;
                }

                if (!data.Success) {
                    this.messageService.add({ severity: 'error', summary: 'Error', detail: data.ErrorMessage });
                    this.loading = false;
                    return;
                }
                this.disciplinary = data;
                this.disciplinary.CreatedAt = moment(this.disciplinary.CreatedAt).format('DD MMM YYYY, hh:mmA');
                this.disciplinary.OffenseDateTime = moment(this.disciplinary.OffenseDateTime).format('DD MMM YYYY, hh:mmA');
                if (this.disciplinary.ComplaintMemberSince) {
                    this.disciplinary.ComplaintMemberSince = moment(this.disciplinary.ComplaintMemberSince).format('DD MMM YYYY');
                }
                if (this.disciplinary.InvestigationStartedAt) {
                    this.disciplinary.InvestigationStartedAt = moment(this.disciplinary.InvestigationStartedAt).format('DD MMM YYYY');
                }
                if (this.disciplinary.InvestigationFinishedAt) {
                    this.disciplinary.InvestigationFinishedAt = moment(this.disciplinary.InvestigationFinishedAt).format('DD MMM YYYY');
                }
                if (this.disciplinary.HearingDateTime) {
                    this.disciplinary.HearingDate = moment(this.disciplinary.HearingDateTime).format('DD MMM YYYY');
                    this.disciplinary.HearingTime = moment(this.disciplinary.HearingDateTime).format('hh:mm');
                }
                if (this.disciplinary.SanctionStartedAt) {
                    this.disciplinary.SanctionStartedAt = moment(this.disciplinary.SanctionStartedAt).format('DD MMM YYYY');
                }
                if (this.disciplinary.SanctionFineshedAt) {
                    this.disciplinary.SanctionFineshedAt = moment(this.disciplinary.SanctionFineshedAt).format('DD MMM YYYY');
                }
                switch (this.disciplinary.DisciplinaryStatusId) {
                    case XpressDisciplinaryStatus.Suspension: {
                        this.disciplinary.StatusColor = '#F77F00';
                        this.disciplinary.StatusBackColor = '#FFEFCC';
                        break;
                    }
                    case XpressDisciplinaryStatus.New: {
                        this.disciplinary.StatusColor = '#FFFFFF';
                        this.disciplinary.StatusBackColor = '#0A84FF';
                        break;
                    }
                    case XpressDisciplinaryStatus.Pending: {
                        this.disciplinary.StatusColor = '#FFFFFF';
                        this.disciplinary.StatusBackColor = '#818181';
                        break;
                    }
                    case XpressDisciplinaryStatus.Hearing: {
                        this.disciplinary.StatusColor = '#FFFFFF';
                        this.disciplinary.StatusBackColor = '#00C0F0';
                        break;
                    }
                    case XpressDisciplinaryStatus.Investigating: {
                        this.disciplinary.StatusColor = '#FFFFFF';
                        this.disciplinary.StatusBackColor = '#004060';
                        break;
                    }
                    case XpressDisciplinaryStatus.Meeting: {
                        this.disciplinary.StatusColor = '#004060';
                        this.disciplinary.StatusBackColor = '#CCD9DF';
                        break;
                    }
                    case XpressDisciplinaryStatus.Cleared: {
                        this.disciplinary.StatusColor = '#004060';
                        this.disciplinary.StatusBackColor = '#BAC5CB';
                        break;
                    }
                    case XpressDisciplinaryStatus.Banned: {
                        this.disciplinary.StatusColor = '#FFFFFF';
                        this.disciplinary.StatusBackColor = '#EB4236';
                        break;
                    }
                    case XpressDisciplinaryStatus.Closed: {
                        this.disciplinary.StatusColor = '#004060';
                        this.disciplinary.StatusBackColor = '#BAC5CB';
                        break;
                    }
                }
                switch (this.disciplinary.DisciplinaryActionId) {
                    case XpressDisciplinaryActionEnum.Suspension: {
                        this.disciplinary.DisciplinaryActionColor = '#F77F00';
                        this.disciplinary.DisciplinaryActionBackColor = '#FFEFCC';
                        break;
                    }
                    case XpressDisciplinaryActionEnum.Closed: {
                        this.disciplinary.DisciplinaryActionColor = '#004060';
                        this.disciplinary.DisciplinaryActionBackColor = '#CCD9DF';
                        break;
                    }
                    case XpressDisciplinaryActionEnum.Ban: {
                        this.disciplinary.DisciplinaryActionColor = '#FFFFFF';
                        this.disciplinary.DisciplinaryActionBackColor = '#EB4236';
                        break;
                    }
                }
                this.loading = false;
            })
            .catch(error => {
                console.log(error);
                this.messageService.add({ severity: 'error', summary: 'Error', detail: error });
                this.loading = false;
            });
    }

    cancel() {
        this.changedShowDisciplinaryDetailSideBar(false);
    }
}
